export const productsConstants = {
    PRODUCTS_REQUEST: 'PRODUCTS_REGISTER_REQUEST',
    PRODUCTS_SUCCESS: 'PRODUCTS_REGISTER_SUCCESS',
    PRODUCTS_FAILURE: 'PRODUCTS_REGISTER_FAILURE',   
};
